module.exports = __webpack_public_path__ + "static/media/img04.140386dd.webp";